import * as Dialog from '@radix-ui/react-dialog'
import { useAppStore } from '@store'
import { useNavigate } from 'react-router-dom'

type Props = {
  message?: string
}

export function ConfirmRegister({ message }: Props) {
  const navigate = useNavigate()
  const closeModal = useAppStore.use.closeModal()
  function handleClickNew() {
    navigate('/planner/login')
    closeModal()
  }

  return (
    <Dialog.Root open={true}>
      <Dialog.Portal>
        <Dialog.Content className='dialog white-background absolute left-1/2 top-1/2 z-50 h-[180px] w-[450px] -translate-x-1/2 -translate-y-1/2 rounded-2xl border-2 border-colorAtemporal bg-C/Color1 p-4 text-left text-xs shadow-xl'>
          <Dialog.Title className='sr-only'>
            {'Registrate y crea tu cuenta en for2home'}
          </Dialog.Title>
          <Dialog.Description className='sr-only'>
            {'Registrate'} - {'Registrate y crea tu cuenta en for2home'}
          </Dialog.Description>
          <div className='flex h-full flex-col items-center justify-center gap-y-4'>
            <p className='text-center font-normal leading-relaxed text-C/Color5'>
              {message ||
                'Se ha enviado un email a la dirección introducida con las instrucciones para activar la cuenta'}
            </p>
            <div className='button container mb-2 flex w-full justify-center'>
              <button
                onClick={handleClickNew}
                className='flex cursor-pointer items-center rounded-xl border border-solid border-C/Color7 bg-C/Color3 px-4 py-2 text-xs font-normal text-C/Color1 transition-colors hover:bg-C/Color2'
              >
                {'Ok'}
              </button>
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
